export class ShiftCalendarItem {
    public time: string;
    public days: number[];

    constructor(time: string, days: number[]) {
        this.time = time;
        this.days = days;
    }
}


// WEBPACK FOOTER //
// ./src/Models/Shifts/ShiftCalendarItem.ts